import { Spacer, SpacerProps } from '@chakra-ui/react'

export const FormSpacer = (props: SpacerProps) => <Spacer h={4} {...props} />
